<template>
  <div>
    <el-card>
      <div class="head-group">
        <div class="left-part">
          <!-- 年份选择 -->
          <div class="rowpart">
            <el-date-picker
              style="width: 160px"
              v-model="year"
              type="year"
              placeholder="选择年"
              format="YYYY"
              value-format="YYYY"
            >
            </el-date-picker>
          </div>
          <!-- 季度选择 -->
          <div class="rowpart">
            <SeasonSelect
              @season="this.season = $event"
              v-model="this.season"
            ></SeasonSelect>
          </div>
        </div>
        <div class="right-part">
          <el-button
            type="primary"
            @click="handleAdd"
            :disabled="disable.addKeyTaskBtn"
            >添加任务</el-button
          >
          <el-button type="primary" @click="doDistribute">批量下发</el-button>
        </div>
      </div>

      <el-scrollbar>
        <el-table
          class="table"
          :data="
            keyTaskList.slice(
              (currentPage - 1) * pagesize,
              currentPage * pagesize
            )
          "
          border
          style="width: 100%"
          height="600"
          :default-sort="{ prop: 'taskId' }"
          @select="handleSelect"
        >
          <el-table-column type="selection" width="55" fixed />
          <template v-for="column in keyTaskTable" :key="column.prop">
            <el-table-column
              :prop="column.prop"
              :label="column.label"
              width="180"
              :formatter="formatter"
            >
            </el-table-column>
          </template>
          <el-table-column label="操作" width="160" fixed="right">
            <template #default="scope">
              <el-button
                v-if="showable.distributeBtn"
                type="text"
                @click="handleDistribute(scope.$index, scope.row)"
                >科室设置</el-button
              >
              <el-button
                v-else
                type="text"
                @click="handleEdit(scope.$index, scope.row)"
                >查看</el-button
              >
              <el-popconfirm
                title="确认删除?"
                @confirm="handleDelete(scope.$index, scope.row)"
                confirm-button-text="是"
                cancel-button-text="否"
              >
                <template #reference>
                  <el-button type="text">删除</el-button>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>

      <!-- 分页 -->
      <div class="pagination-block">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="keyTaskList.length"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 添加关键任务模态框 -->
    <el-dialog v-model="showable.addKeyTask" title="添加关键任务" width="40%">
      <!-- 添加任务表单 -->
      <el-form label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="任务分类">
              <el-input v-model="keyTaskForm.taskCategory"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="任务类型">
              <TaskTypeSelect
                @taskType="keyTaskForm.taskType = $event"
                v-model="keyTaskForm.taskType"
              ></TaskTypeSelect>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="牵头科室">
              <DepartmentSelectV2
                v-model="keyTaskForm.leaderDept"
                @departmentId="this.keyTaskForm.leaderDept = $event"
                :allowMultiple="true"
              >
              </DepartmentSelectV2>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="责任人">
              <EmployeeSelectV2
                v-model="keyTaskForm.respPerson"
                :depIdArr="[this.departmentId]"
                :allowMultiple="true"
              ></EmployeeSelectV2>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="配合科室">
              <DepartmentSelectV2
                v-model="keyTaskForm.coDept"
                @departmentId="this.keyTaskForm.coDept = $event"
                :allowMultiple="true"
              >
              </DepartmentSelectV2>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="具体工作人员">
              <EmployeeSelectV2
                v-model="keyTaskForm.specificPerson"
                :depIdArr="[this.departmentId]"
                :allowMultiple="true"
              ></EmployeeSelectV2>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="工作内容">
              <el-input
                type="textarea"
                v-model="keyTaskForm.taskDetail"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="标准要求">
              <el-input
                type="textarea"
                v-model="keyTaskForm.evaCriterion"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row gutter="30">
          <el-col :span="12">
            <el-form-item label="开始时间">
              <el-date-picker
                v-model="keyTaskForm.beginDate"
                type="date"
                placeholder="选择日期"
                :locale="zhCn"
                style="width: 180px"
                value-format="YYYY-MM-DD"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="截止时间">
              <el-date-picker
                v-model="keyTaskForm.endDate"
                type="date"
                placeholder="选择日期"
                :locale="zhCn"
                style="width: 180px"
                value-format="YYYY-MM-DD"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row gutter="30">
          <el-col>
            <el-form-item label="分值">
              <el-input v-model="keyTaskForm.totalScore"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                type="textarea"
                v-model="keyTaskForm.remarks"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="botton-btn">
          <el-button
            type="primary"
            @click="addTask"
            :disabled="disable.confirmAddBtn"
            >确认添加</el-button
          >
          <el-button type="default" @click="doCancel">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!-- 指定具体工作人员 -->
    <el-dialog
      v-model="showable.distributeForm"
      title="指定具体工作人员"
      width="40%"
    >
      <div class="right-btn">
        <el-button type="primary" @click="handleAddItem">添加</el-button>
      </div>

      <el-form label-width="120px">
        <el-table :data="distrubuteList">
          <el-table-column type="index" width="50" />
          <el-table-column
            prop="specificPerson"
            label="具体工作人员"
            width="180"
          >
            <template #default="scope">
              <EmployeeSelectV2
                v-model="scope.row.specificPerson"
                :depIdArr="[this.departmentId]"
              ></EmployeeSelectV2>
            </template>
          </el-table-column>
          <el-table-column prop="proportion" label="评分占比" width="180">
            <template #default="scope">
              <el-input v-model="scope.row.proportion"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="operation" label="操作" width="200">
            <template #default="scope">
              <el-popconfirm
                title="确认删除?"
                @confirm="deletePartial(scope.$index, scope.row)"
                confirm-button-text="是"
                cancel-button-text="否"
              >
                <template #reference>
                  <el-button type="text">删除</el-button>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="right-btn table">
          <el-button type="primary" @click="addItem">确认</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import KeyTaskManage from "../api/KeyTaskManage";
export default KeyTaskManage;
</script>

<style scoped lang="scss">
.head-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.left-part {
  display: flex;
}

.rowpart {
  width: 160px;
  margin-right: 10px;
}

.table {
  margin-top: 20px;
}

.pagination-block {
  margin-top: 20px;
}

.right-btn {
  text-align: end;
}

.botton-btn {
  text-align: end;
}
</style>